import { createGlobalStyle, css } from 'styled-components';

const appGlobalStyles = css`
  * {
    box-sizing: border-box;
    font-family: ${({ theme }) => theme?.fontFamily?.main};
  }

  .no-window-scrollbars::-webkit-scrollbar {
    display: none;
  }

  .no-window-scrollbars {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  // show scrollbars
  ::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 7px;
    height: 7px;
    background-color: white;
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
  // - end show scrollbars

  html,
  body,
  #root {
    height: 100%;
  }

  html {
    font-size: 16px;
  }

  body {
    overflow-y: scroll;
    margin: 0;
    font-style: normal;
    font-weight: 400;
    line-height: 1rem;
    font-size: ${({ theme }) => theme?.fontSize?.body};
    background-color: ${({ theme }) => theme?.palette?.background};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: ${({ theme }) => `0 0 ${theme.spacing.default}`};
    padding: 0;
    font-weight: 400;
  }

  h1 {
    font-size: ${({ theme }) => theme.fontSize.h1};
  }

  h2 {
    font-size: ${({ theme }) => theme.fontSize.h2};
  }

  h3 {
    font-size: ${({ theme }) => theme.fontSize.h3};
  }

  h4 {
    font-size: ${({ theme }) => theme.fontSize.h4};
  }

  h5 {
    font-size: ${({ theme }) => theme.fontSize.h5};
  }

  h6 {
    font-size: ${({ theme }) => theme.fontSize.h6};
  }

  .section-header {
    font-size: ${({ theme }) => theme.fontSize.sectionHeader};
    font-weight: 600;
    color: ${({ theme }) => theme.fontSize.sectionHeader}; //
  }

  // override MUI DataGrid font size to match app default
  .MuiDataGrid-root {
    font-size: ${({ theme }) => theme.fontSize.default} !important;
  }

  // force Typography components from libs to inherit this font-size
  .body1,
  .body2 {
    font-size: inherit !important;
  }

  p {
    margin: ${({ theme }) => `0 0 ${theme.spacing.default}`};
  }

  a {
    text-decoration: none;
    color: ${({ theme }) => theme?.palette?.linkColor};

    &:hover {
      color: ${({ theme }) => theme?.palette?.linkHoverColor};
    }
  }
`;

export const GlobalStyle = createGlobalStyle`
  ${appGlobalStyles}
`;
